import { post, put } from './http';
import { dataLayerAddToCart } from '../Services/Gtm.service';

export const add = async ({ articleNumber, quantity = 1 }) => {
  if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
    throw 'Invalid quantity';
  }

  const response = await post('/api/cart/add', {
    articleNumber,
    quantity: parseFloat(quantity),
  });

  var result = await response.json();

  try {
    addToDataLayer([{articleNumber, quantity}], result.orderRows);
  } catch (err) { }

  return result;
};

export const reorder = async (orderId) => {
  const response = await post('/api/cart/reorder', { orderId });
  return response.json();
};

export const addMultiple = async (products) => {
  if (
    products.filter(
      (p) => !p.quantity || isNaN(p.quantity) || parseInt(p.quantity) <= 0
    ).length > 0
  ) {
    throw 'Invalid quantity';
  }
  const response = await post('/api/cart/addMultiple', products);
  var result = await response.json();

  try {
    addToDataLayer(products, result.orderRows);
  } catch (err) { }

  return result;
};

export const addConfiguration = async (products) => {
  if (
    products.filter(
      // -1 to allow quantity like 0.16
      (p) => !p.quantity || isNaN(p.quantity) || parseFloat(p.quantity) <= 0
    ).length > 0
  ) {
    throw 'Invalid quantity';
  }
  const response = await post('/api/cart/addConfiguration', products);
  var result = await response.json();

  try {
    addToDataLayer(products, result.orderRows);
  } catch (err) { }

  return result;
};


export const updateQuantity = async (
  articleNumber,
  quantity,
  orderRowId,
  abortController
) => {
  const res = await put(
    `/api/cart/update`,
    { articleNumber, quantity, orderRowId },
    abortController
  );
  return await res.json();
};

const addToDataLayer = (products, orderRows) => {
  let responseProducts = [];
  
  orderRows.map((row) => {
    for (const i in products) {
      if (Object.hasOwnProperty.call(products, i)) {
        if (products[i].articleNumber === row.articleNumber) {
          const index = responseProducts.findIndex(e => e.articleNumber === row.articleNumber);
  
          if (index === -1) {
            row.gtmEcommerceItem.quantity = products[i].quantity;
            row.gtmEcommerceItem.index = responseProducts.length;
            responseProducts.push(row);
          }
        }
      }
    }
  });

  const gtmEcommerceItems = responseProducts.map(p => p.gtmEcommerceItem);
  if (gtmEcommerceItems) {
    dataLayerAddToCart(gtmEcommerceItems);
  }
}
